/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_range = /** @type {(inputs: { min: NonNullable<unknown>, max: NonNullable<unknown> }) => string} */ (i) => {
	return `Mezi ${i.min} a ${i.max}`
};

const da_range = /** @type {(inputs: { min: NonNullable<unknown>, max: NonNullable<unknown> }) => string} */ (i) => {
	return `Mellem ${i.min} og ${i.max}`
};

const de_range = /** @type {(inputs: { min: NonNullable<unknown>, max: NonNullable<unknown> }) => string} */ (i) => {
	return `Zwischen ${i.min} und ${i.max}`
};

const en_range = /** @type {(inputs: { min: NonNullable<unknown>, max: NonNullable<unknown> }) => string} */ (i) => {
	return `Between ${i.min} and ${i.max}`
};

const es_range = /** @type {(inputs: { min: NonNullable<unknown>, max: NonNullable<unknown> }) => string} */ (i) => {
	return `Entre ${i.min} y ${i.max}`
};

const fr_range = /** @type {(inputs: { min: NonNullable<unknown>, max: NonNullable<unknown> }) => string} */ (i) => {
	return `Entre ${i.min} et ${i.max}`
};

const hu_range = /** @type {(inputs: { min: NonNullable<unknown>, max: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.min} és ${i.max} között`
};

const it_range = /** @type {(inputs: { min: NonNullable<unknown>, max: NonNullable<unknown> }) => string} */ (i) => {
	return `Tra ${i.min} e ${i.max}`
};

const nl_range = /** @type {(inputs: { min: NonNullable<unknown>, max: NonNullable<unknown> }) => string} */ (i) => {
	return `Tussen ${i.min} en ${i.max}`
};

const pl_range = /** @type {(inputs: { min: NonNullable<unknown>, max: NonNullable<unknown> }) => string} */ (i) => {
	return `Od ${i.min} do ${i.max}`
};

const pt_range = /** @type {(inputs: { min: NonNullable<unknown>, max: NonNullable<unknown> }) => string} */ (i) => {
	return `Entre ${i.min} e ${i.max}`
};

const sv_range = /** @type {(inputs: { min: NonNullable<unknown>, max: NonNullable<unknown> }) => string} */ (i) => {
	return `Mellan ${i.min} och ${i.max}`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ min: NonNullable<unknown>, max: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const range = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.range(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("range", locale)
	if (locale === "cs") return cs_range(inputs)
	if (locale === "da") return da_range(inputs)
	if (locale === "de") return de_range(inputs)
	if (locale === "en") return en_range(inputs)
	if (locale === "es") return es_range(inputs)
	if (locale === "fr") return fr_range(inputs)
	if (locale === "hu") return hu_range(inputs)
	if (locale === "it") return it_range(inputs)
	if (locale === "nl") return nl_range(inputs)
	if (locale === "pl") return pl_range(inputs)
	if (locale === "pt") return pt_range(inputs)
	return sv_range(inputs)
};